import React, { useCallback, useEffect, useState } from 'react';
import { Props } from './AccountCard.interface';
import './account_card.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import {
  faUserPlus,
  faFlag,
  faBirthdayCake,
} from '@fortawesome/free-solid-svg-icons';
import FaIconView from '../FaIconView/FaIconView';
import { firestore } from '../../utils/firebase';
import { Account } from '../../pages/Accounts/Accounts.interface';

const AccountCard: React.FC<Props> = (props) => {
  const { account, category } = props;

  const [accountData, setAccountData] = useState<Account>(account);
  const [liked, setLiked] = useState(false);

  const setLikedStatus = useCallback(() => setLiked(isAlreadyLiked()), []);

  useEffect(() => {
    setLikedStatus();
  }, [setLikedStatus]);

  const likeAccount = () => {
    setAccountLikes(accountData.likes + 1);

    // save the account to liked accounts
    setLiked(true);
    addToLikedAccounts();
  };

  const removeLike = () => {
    setAccountLikes(accountData.likes - 1);

    // remove the account from liked accounts
    setLiked(false);
    removeFromLikedAccounts();
  };

  const setAccountLikes = (likes: number) => {
    firestore
      .collection('accounts')
      .doc(accountData.id)
      .set({ likes: likes }, { merge: true });

    setAccountData({ ...accountData, likes });
  };

  const isAlreadyLiked = () => {
    return getLikedAccounts().includes(accountData.id);
  };

  const addToLikedAccounts = () => {
    const likedIds = getLikedAccounts();
    likedIds.push(accountData.id);
    localStorage.setItem('likedAccounts', JSON.stringify(likedIds));
  };

  const removeFromLikedAccounts = () => {
    const likedIds = getLikedAccounts();
    likedIds.splice(likedIds.indexOf(accountData.id), 1);
    localStorage.setItem('likedAccounts', JSON.stringify(likedIds));
  };

  const getLikedAccounts = () => {
    return JSON.parse(
      localStorage.getItem('likedAccounts') || '[]',
    ) as string[];
  };

  const increaseViews = () => {
    const views = accountData.views + 1;
    firestore
      .collection('accounts')
      .doc(accountData.id)
      .set({ views: views }, { merge: true });

    setAccountData({ ...accountData, views });
  };

  return (
    <div
      className="card-container"
      style={{
        borderTop: `thick solid ${category.bgColor}`,
      }}
    >
      <div className="ca-header">
        <h5 className="account-name">{accountData.name}</h5>

        <div className="header-icons">
          <FontAwesomeIcon
            className="header-icon"
            icon={['fab', category.id.toLowerCase() as IconName]}
          />
          {/* <FontAwesomeIcon
            className="header-icon"
            icon={accountData.gender.toLowerCase() as IconName}
          /> */}
        </div>
      </div>

      <div className="location-age-container flex-row">
        <FaIconView
          icon={faFlag}
          label={`${accountData.country} - ${accountData.city}`}
          containerStyle="icon-view-container"
          iconStyle="icon-view-icon grey-icon"
          iconFlip="horizontal"
          labelStyle="location-age-label"
          iconSize="xs"
        />

        <FaIconView
          icon={accountData.gender.toLowerCase()}
          label={accountData.gender === 'male' ? 'ذكر' : 'أنثى'}
          containerStyle="icon-view-container"
          iconStyle="icon-view-icon grey-icon"
          labelStyle="location-age-label"
          iconSize="xs"
        />

        <FaIconView
          icon={faBirthdayCake}
          label={`${accountData.age} سنة`}
          containerStyle="icon-view-container"
          iconStyle="icon-view-icon grey-icon"
          labelStyle="location-age-label"
          iconSize="xs"
        />
      </div>

      <div className="account-bio">
        <p>{accountData.bio}</p>
      </div>

      <div className="counters">
        <div className="counters-container">
          <FaIconView
            icon="heart"
            label={accountData.likes}
            isButton
            containerStyle={
              liked
                ? 'icon-view-container liked-account'
                : 'icon-view-container'
            }
            iconStyle={
              liked ? 'icon-view-icon liked-icon' : 'icon-view-icon grey-icon'
            }
            onClick={liked ? removeLike : likeAccount}
          />
          <div className="divider"></div>
          <FaIconView
            icon="eye"
            containerStyle="icon-view-container"
            iconStyle="icon-view-icon grey-icon"
            label={accountData.views}
          />
        </div>
      </div>

      <div
        className="flex-row footer-buttons"
        style={{
          backgroundColor: category.bgColor,
          color: category.frontColor,
        }}
      >
        <a
          href={`${category.link}${accountData.username}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            role="button"
            className="flex-row add-button"
            style={{
              color: category.frontColor,
            }}
            onClick={increaseViews}
          >
            <FontAwesomeIcon className="add-icon" size="1x" icon={faUserPlus} />
            <h6 className="clear-margin">{accountData.username}</h6>
          </div>
        </a>
      </div>
    </div>
  );
};

export default AccountCard;
